import * as Api from '../api/Api';
import createAxios from '../api/WiseOwl';

export const getAll = (projectId) => {
    return createAxios().get(Api.PATH_ORCHESTRATORS, {
        params: {
            projectId
        }
    });
};
